import { Button, mergeClasses } from "@fluentui/react-components";
import {
  ChevronDoubleLeft16Regular,
  ChevronDoubleRight16Regular,
} from "@fluentui/react-icons";

import { useStyles } from "./SidebarHeader.styles";
import { ISidebarHeaderProps } from "./SidebarHeader.types";

export const SidebarHeader = ({
  isCollapsed,
  isVisuallyExpanded,
  onToggleCollapse,
}: ISidebarHeaderProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div
      className={mergeClasses(
        styles.sidebarHeader,
        !isVisuallyExpanded && styles.sidebarHeaderCollapsed,
      )}
    >
      <div className={styles.nhLogo}>NH</div>
      <span
        className={mergeClasses(
          styles.headerTitle,
          !isVisuallyExpanded && styles.headerTitleHidden,
        )}
      >
        Project IQ
      </span>
      <Button
        appearance="transparent"
        className={styles.collapseButton}
        icon={
          isCollapsed ? (
            <ChevronDoubleRight16Regular />
          ) : (
            <ChevronDoubleLeft16Regular />
          )
        }
        onClick={onToggleCollapse}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      />
    </div>
  );
};
